export type AuthBootstrapOutcome = "completed" | "timed_out" | "failed";

export async function runAuthBootstrap(
  task: () => Promise<void>,
  timeoutMs: number,
): Promise<AuthBootstrapOutcome> {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  const timeoutPromise = new Promise<AuthBootstrapOutcome>((resolve) => {
    timeoutId = setTimeout(() => resolve("timed_out"), timeoutMs);
  });

  const taskPromise = task()
    .then(() => "completed" as const)
    .catch(() => "failed" as const);

  const outcome = await Promise.race([taskPromise, timeoutPromise]);
  if (timeoutId) {
    clearTimeout(timeoutId);
  }

  return outcome;
}
